import React from 'react';

import { routeDirectory } from 'modules';
import { Navigate } from 'react-router-dom';

import * as Redirect from './components/Redirect';
import * as dataService from './dataService';



interface IProps {
  superAdminOnly?: boolean;
  children: React.ReactNode | React.ReactNode[];
}

export const FC: React.FC<IProps> = props => {
  const { data, loading } = dataService.useAuthWrapper();



  if (data.authStatus === 'noAttemptMade' || loading) {
    return null;
  }

  if (data.authStatus === 'notLoggedIn') {
    return (
      <Navigate
        to={routeDirectory.authentication.login.path()}
        replace />
    );
  }

  // At this point the user is logged in.
  return (
    <Redirect.FC appAuthStatus={data.appAuthStatus}>
      {props.children}
    </Redirect.FC>
  );
};
